import React from "react";
import { Steps } from "primereact/steps";

interface FormHeaderProps {
  sectionHeaders: any[];
  activeSection: string;
  setActiveSection: (section: string) => void;
  validateCurrentSectionForm: () => boolean;
  toast: any;
}

const FormHeader: React.FC<FormHeaderProps> = ({ sectionHeaders, activeSection, setActiveSection, validateCurrentSectionForm, toast }) => {
  // active section
  const activeIndex = sectionHeaders.findIndex((section) => section.key === activeSection);

  const stepItems = sectionHeaders?.map((section, index) => ({
    label: section.label,
    command: () => {
      // Allow going back
      if (index <= activeIndex) {
        setActiveSection(section.key);
        return;
      }

      // Allow going forward only if valid
      if (!validateCurrentSectionForm()) {
        toast.current?.show({
          severity: "error",
          summary: "Validation Error",
          detail: "Please complete the current step before proceeding.",
        });
        return;
      }

      setActiveSection(section.key);
    },
  }));

  return (
    <div className="steps-wrapper">
      <Steps model={stepItems} activeIndex={activeIndex} readOnly={false} className="section-navigation step-customize" />
      <div className="steps-progress-bar"></div>
    </div>
  );
};

export default FormHeader;
